import React, { Component } from 'react';
import { string, shape, bool, func } from 'prop-types';
import { TableCell, Tooltip, TableSortLabel } from '@mui/material';

class Cell extends Component {
  sortBy = name => () => {
    const { onSort } = this.props;
    onSort(name);
  };

  render() {
    const { order, label, name } = this.props;

    return (
      <TableCell
        sx={{
          pt: 0,
          pb: 0,
          fontSize: 13,
        }}
      >
        <Tooltip title="Sort" enterDelay={300}>
          <TableSortLabel
            active={order.by === name}
            onClick={this.sortBy(name)}
            direction={order.isReverse ? 'desc' : 'asc'}
          >
            {label}
          </TableSortLabel>
        </Tooltip>
      </TableCell>
    );
  }
}

Cell.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  onSort: func.isRequired,
  order: shape({
    by: string.isRequired,
    isReverse: bool.isRequired,
  }).isRequired,
};

export default Cell;
